import React, { useCallback, useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Typography, Box, Paper } from '@material-ui/core';
import customAxios from '../util/Api';
import authHeader from '../../../services/auth/jwt/auth-header';

// icons
import ReceiptIcon from '@material-ui/icons/Receipt';
import EuroIcon from '@material-ui/icons/Euro';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import FenceIcon from '@mui/icons-material/Fence';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import AddTaskIcon from '@mui/icons-material/AddTask';
import FeedRoundedIcon from '@mui/icons-material/FeedRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import { Store } from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InboxIcon from '@mui/icons-material/Inbox';
import GavelIcon from '@mui/icons-material/Gavel';
import EditIcon from '@mui/icons-material/Edit';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SummarizeIcon from '@mui/icons-material/Summarize';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import { Alert, Button, useMediaQuery } from '@mui/material';
import { forceLogout, isRoleAllowed } from 'routes/accessControl';

// icon constants (no inline color — handled by card now)
const crmIcon = <PermContactCalendarIcon />;
const reportIcon = <AssignmentIcon />;
const tasksIcon = <AddTaskIcon />;
const receiptIcon = <ReceiptIcon />;
const euroIcon = <EuroIcon />;
const formIcon = <FeedRoundedIcon />;
const hfIcon = <AssignmentRoundedIcon />;
const storeIcon = <Store />;
const pricingListIcons = <FeaturedPlayListIcon />;
const notificationIcon = <CircleNotificationsIcon />;
const fenceIcon = <FenceIcon />;
const mapViewIcon = <AddLocationAltIcon />;
const personIcon = <PersonOutlineIcon />;
const MetaDataSettings = <ManageAccountsIcon />;
const quickContractIcon = <GavelIcon />;
const EditMetadataIcon = <EditIcon />;
const LengthCheckerIcon = <FactCheckIcon />;
const PowerBIReportsIcon = <SummarizeIcon />;
const HelpDeskIcon = <HelpCenterIcon />;

// all dashboard cards
const dashBoardPageData = [
  { id: 1, cardTitle: 'CRM', cardHref: '/crm/contactsOverview-page', icon: crmIcon, backgroundColor: '#0795F4' },
  { id: 3, cardTitle: 'Site Assessment', cardHref: '/siteAssessment', icon: reportIcon, backgroundColor: '#00A99A' },
  { id: 10, cardTitle: 'Timber Sales Pricing List', cardHref: '/timberSalesPricingList', icon: pricingListIcons, backgroundColor: '#019600' },
  { id: 4, cardTitle: 'Site Contracts', cardHref: '/siteContracts', icon: receiptIcon, backgroundColor: '#1fa763' },
  { id: 5, cardTitle: 'Chipper LowLoader', cardHref: '/chipper-loader', icon: receiptIcon, backgroundColor: '#8bc400' },
  { id: 5, cardTitle: 'Dockets', cardHref: '/dockets', icon: receiptIcon, backgroundColor: '#e0a800' },
  { id: 6, cardTitle: 'Woodchip Samples', cardHref: '/woodchipSamples', icon: tasksIcon, backgroundColor: '#d4b900' },
  { id: 7, cardTitle: 'Purchase Requisition', cardHref: '/purchaseRequisition', icon: euroIcon, backgroundColor: '#e0392f' },
  { id: 8, cardTitle: 'H/F Ops', cardHref: '/hfOps', icon: hfIcon, backgroundColor: '#c9b91f' },
  { id: 9, cardTitle: 'General Tasks', cardHref: '/generalTask', icon: hfIcon, backgroundColor: '#8a5a2b' },
  { id: 11, cardTitle: 'Managing Stores', cardHref: '/managingStores', icon: storeIcon, backgroundColor: '#28a745' },
  { id: 12, cardTitle: 'Notifications', cardHref: '/notifications', icon: notificationIcon, backgroundColor: '#20925a' },
  { id: 13, cardTitle: 'GeoFencing', cardHref: '/geofencing', icon: fenceIcon, backgroundColor: '#e08e00' },
  { id: 14, cardTitle: 'MapView', cardHref: '/mapView', icon: mapViewIcon, backgroundColor: '#c060d0' },
  { id: 15, cardTitle: 'Rate Card', cardHref: '/rateCard', icon: euroIcon, backgroundColor: '#009688' },
  { id: 16, cardTitle: 'Profile Management', cardHref: '/profileManagement', icon: personIcon, backgroundColor: '#c060a0' },
  { id: 2, cardTitle: 'FORMS', cardHref: '/forms', icon: formIcon, backgroundColor: '#e0850b' },
  { id: 17, cardTitle: 'Manage Customers Weighbridge', cardHref: '/manageWeighbridge', icon: MetaDataSettings, backgroundColor: '#c9605a' },
  { id: 18, cardTitle: 'Quick Contract', cardHref: '/quickContract', icon: quickContractIcon, backgroundColor: '#d9481f' },
  { id: 18, cardTitle: 'Length Checker', cardHref: '/lengthChecker', icon: LengthCheckerIcon, backgroundColor: '#2178c9' },
  { id: 19, cardTitle: 'Edit Metadata', cardHref: '/editMetadata', icon: EditMetadataIcon, backgroundColor: '#c96560' },
  { id: 19, cardTitle: 'Edit Departments/Machines', cardHref: '/editDepartmentAndMachines', icon: EditMetadataIcon, backgroundColor: '#8a6360' },
  { id: 20, cardTitle: 'Power BI Reports', cardHref: '/powerBIReports', icon: PowerBIReportsIcon, backgroundColor: '#8a6360' },
  { id: 20, cardTitle: 'Help Desk', cardHref: '/helpdesk', icon: HelpDeskIcon, backgroundColor: '#668a60' },
  // { id: 5, cardTitle: 'Docket Web Form', cardHref: '/docket-form', icon: receiptIcon, backgroundColor: '#e00056' },
];

const StrategyPlanBanner = () => {
  const handleOpenStrategyPlan = useCallback(() => {
    const url =
      'https://worrellharvestingltd.sharepoint.com/:x:/s/01.FilesStrategyPlans/IQCquKGKL65JTbj2JJzXPIVvASmkrxuMECA6AI8VX_MEUPs?e=hi01Zk';

    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <Alert
      severity="info"
      action={
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={handleOpenStrategyPlan}
        >
          Open in Teams
        </Button>
      }
      sx={{ mb: 2 }}
    >
      <strong>Strategy plan</strong>
      <br />
      Review the latest strategy plan in Teams to stay aligned with
      priorities and updates.
    </Alert>
  );
};

// compact card
// compact card
const DashboardCard = ({ title, icon, color, href }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Paper
      elevation={0}
      onClick={() => (window.location.href = href)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 16,
        padding: '18px 12px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 10,
        height: '100%',
        minHeight: 112,
        border: `1px solid ${hovered ? color : '#eef0f2'}`,
        background: hovered
          ? `linear-gradient(180deg, ${color}0d 0%, #ffffff 60%)`
          : '#ffffff',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'transform 200ms cubic-bezier(0.4,0,0.2,1), box-shadow 200ms ease, border-color 200ms ease, background 200ms ease',
        boxShadow: hovered
          ? `0 12px 24px -8px ${color}55, 0 4px 8px rgba(16,24,40,0.06)`
          : '0 1px 3px rgba(16,24,40,0.06)',
      }}
    >
      {/* icon badge */}
      <Box
        style={{
          width: 42,
          height: 42,
          borderRadius: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: hovered
            ? color
            : `linear-gradient(135deg, ${color}22, ${color}12)`,
          color: hovered ? '#fff' : color,
          flexShrink: 0,
          transition: 'all 220ms ease',
          boxShadow: hovered ? `0 6px 14px -4px ${color}88` : 'none',
        }}
      >
        {React.cloneElement(icon, { style: { fontSize: 21 } })}
      </Box>

      <Typography
        style={{
          fontSize: 12.5,
          fontWeight: 600,
          color: '#1f2937',
          lineHeight: 1.3,
          letterSpacing: 0.1,
          padding: '0 2px',
        }}
      >
        {title}
      </Typography>

      {/* accent underline */}
      <Box
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: hovered ? 'translateX(-50%) scaleX(1)' : 'translateX(-50%) scaleX(0)',
          width: '60%',
          height: 3,
          borderRadius: '3px 3px 0 0',
          background: color,
          transition: 'transform 220ms ease',
        }}
      />
    </Paper>
  );
};

const DashboardPage = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [accessibleCards, setAccessibleCards] = useState([]);
  const [noAccess, setNoAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    const fetchUserAccess = async () => {
      try {
        const profileRes = await customAxios.get('/User/GetUserProfile', {
          headers: authHeader(),
        });
        const user = profileRes?.data;
        setUserProfile(user);

        if (!user || !isRoleAllowed(user.roleId)) {
          setNoAccess(true);
          return;
        }

        const [allButtonsRes, roleButtonsRes] = await Promise.all([
          customAxios.get('/User/GetAllButtons', { headers: authHeader() }),
          customAxios.get(`/User/GetRoleButtons?roleId=${user.roleId}`, { headers: authHeader() }),
        ]);

        const allButtons = allButtonsRes?.data || [];
        const roleButtons = roleButtonsRes?.data || [];

        const accessibleButtonNames = roleButtons
          .map(r => {
            const btn = allButtons.find(b => b.buttonId === r.buttonId);
            return btn?.buttonId;
          })
          .filter(Boolean);

        const filteredCards = dashBoardPageData.filter(card => accessibleButtonNames.includes(card.id));

        if (filteredCards.length === 0) setNoAccess(true);
        setAccessibleCards(filteredCards);
      } catch (error) {
        console.error('Error fetching access:', error);
        setNoAccess(true);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAccess();
  }, []);

  if (noAccess) {
    return (
      <PageContainer>
        <Box display="flex" alignItems="center" justifyContent="center" height="80vh" style={{ backgroundColor: '#f9fafb' }}>
          <Paper elevation={3} style={{ padding: 24, maxWidth: 420, textAlign: 'center' }}>
            <InboxIcon style={{ fontSize: 64, color: '#c4c9d0', marginBottom: 12 }} />
            <Typography variant="h6" style={{ color: '#111827', fontWeight: 600, marginBottom: 6 }}>
              You don't have the required permission
            </Typography>
            <Typography variant="body2" style={{ color: '#6b7280' }}>
              You are not allowed access to this section. Please contact your administrator for help.
            </Typography>
          </Paper>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      {loading ? (
        <Box display="flex" alignItems="center" justifyContent="center" height="60vh">
          <Typography variant="body2" style={{ color: '#9ca3af' }}>
            Loading dashboard…
          </Typography>
        </Box>
      ) : (
        <>
          <StrategyPlanBanner />

          <Box
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(5, 1fr)',
              gap: 12,
              padding: '4px 2px',
            }}
          >
            {accessibleCards.map((item, idx) => (
              <DashboardCard
                key={`${item.id}-${idx}`}
                title={item.cardTitle}
                icon={item.icon}
                color={item.backgroundColor}
                href={item.cardHref}
              />
            ))}
          </Box>
        </>
      )}
    </PageContainer>
  );
};

export default DashboardPage;